import React, { useEffect, useState, useRef } from 'react';
import EditOrderModal from '../components/EditOrderModal';
import Modal from 'react-modal';
import { DatePicker } from 'antd';
import { data, useLocation } from 'react-router-dom';

import {
  downloadPdf,
  exportOrders,
  fetchDeliveryStatuses,
  fetchOrders,
  fetchOrderStatuses,
  fetchPaymentStatuses,
  fetchProcessCategories,
  importOrders,
  printView,
  toggleReadStatus,
  toggleReadStatusBulk,
  updateBulkOrders,
  updateOrder,
  updateStatus,
} from '../services/ordersService';
import {
  showErrorToast,
  showSuccessToast,
  showWarningToast,
} from '../../../utils/toastHelper';
import { usePermissions } from '../../../contexts/PermissionsContext';
import { useTranslation } from 'react-i18next';
import Pagination from '../../../components/Pagination';
import ViewOrderModal from '../components/ViewOrderModal';
import ImportOrdersModal from '../components/ImportOrdersModal';
import AddOrderModalUpdate from '../components/AddOrderModalUpdate';
import AddCateringModal from '../components/AddCateringModal';
import EditCateringModal from '../components/EditCateringOrder';
import FBZOrdersTable from '../components/FBZOrdersTable';
import OrdersTable from '../components/OrdersTable';
import { handlePrintOrderInfo } from '../components/printOrderInfo';
import BulkUpdateConfirmationModal from '../components/BulkUpdateConfirmationModal';
import FileNames from '../../../constants/fileNames';
const { RangePicker } = DatePicker;
const permissionMap = {
  '/': 'FBZ_ORDER_INFO_HOME_PAGE',
  '/orders-catering': 'CATERING_ORDER_INFO_HOME_PAGE',
  '/fbz-orders': 'FBZ_ORDER_INFO_HOME_PAGE_2',
  '/catering-orders': 'CATERING_ORDER_INFO_HOME_PAGE_2',
};
const yellowColorObject = {
  code: 'processing',
  class: 'yellow',
  images: {
    // print: 'images/print-yellow.svg',
    // view: 'images/view-yellow.svg',
    // edit: 'images/edit-yellow.svg',
    // clone: 'images/clone-yellow.svg',
    // pdf: 'images/pdf-yellow.svg',
    print: 'images/black-print.svg',
    view: 'images/black-view.svg',
    edit: 'images/black-edit.svg',
    clone: 'images/black-clone.svg',
    pdf: 'images/black-pdf.svg',
  },
};
const greenColorObject = {
  code: 'processing',
  class: 'green',
  images: {
    // print: 'images/green-print.svg',
    // view: 'images/green-view.svg',
    // edit: 'images/green-edit.svg',
    // clone: 'images/clone-green.svg',
    // pdf: 'images/pdf-green.svg',
    print: 'images/black-print.svg',
    view: 'images/black-view.svg',
    edit: 'images/black-edit.svg',
    clone: 'images/black-clone.svg',
    pdf: 'images/black-pdf.svg',
  },
};
const blueColorObject = {
  code: 'processing',
  class: 'blue',
  images: {
    // print: 'images/blue-print.svg',
    // view: 'images/blue-view.svg',
    // edit: 'images/blue-edit.svg',
    // clone: 'images/clone-blue.svg',
    // pdf: 'images/pdf-blue.svg',
    print: 'images/black-print.svg',
    view: 'images/black-view.svg',
    edit: 'images/black-edit.svg',
    clone: 'images/black-clone.svg',
    pdf: 'images/black-pdf.svg',
  },
};
const redColorObject = {
  code: 'processing',
  class: 'red',
  images: {
    // print: 'images/red-print.svg',
    // view: 'images/red-view.svg',
    // edit: 'images/red-edit.svg',
    // clone: 'images/clone-red.svg',
    // pdf: 'images/pdf-red.svg',
    print: 'images/black-print.svg',
    view: 'images/black-view.svg',
    edit: 'images/black-edit.svg',
    clone: 'images/black-clone.svg',
    pdf: 'images/black-pdf.svg',
  },
};
const purpleColorObject = {
  code: 'processing',
  class: 'purple',
  images: {
    print: 'images/purple-print.svg',
    view: 'images/purple-view.svg',
    edit: 'images/purple-edit.svg',
    clone: 'images/clone-purple.svg',
    pdf: 'images/pdf-purple.svg',
  },
};
const colorMappings = {
  處理中: yellowColorObject,
  Processing: yellowColorObject,

  完成: greenColorObject,
  completed: greenColorObject,

  取消: redColorObject,
  cancelled: redColorObject,

  等待中: blueColorObject,
  Pending: blueColorObject,

  updated: purpleColorObject,
};

export default function FBZOrders() {
  const { t } = useTranslation('Order');
  const location = useLocation();
  const [isOrdersCatering, setIsOrdersCatering] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [actionFrom, setActionFrom] = useState('');
  const [addCateringModal, setAddCateringModal] = useState(false);
  const [editCateringModal, setEditCateringModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [importModal, setImportModal] = useState(false);
  const [bulkUpdateConfirmationModal, setBulkUpdateConfirmationModal] =
    useState(false);
  const [selectedOrdersEdit, setSelectedOrdersEdit] = useState('');
  const [modalActionType, setModalActionType] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedOrders, setSelectedOrders] = useState(new Set());
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [processCategories, setProcessCategories] = useState([]);
  const [deliveryStatuses, setDeliveryStatuses] = useState([]);
  const [orderStatuses, setOrderStatuses] = useState([]);
  const [paymentStatuses, setPaymentStatuses] = useState([]);
  const [deliveryDateFilter, setDeliveryDateFilter] = useState([]);
  const [deliveryDateFilterCommonState, setDeliveryDateFilterCommonState] =
    useState(null);
  const [bulkOrderStatusAction, setBulkOrderStatusAction] = useState('');
  const [bulkDeliveryStatusAction, setBulkDeliveryStatusAction] = useState('');
  const [bulkReadStatus, setBulkReadStatus] = useState('');
  const [bulkFunctionForConfirmation, setBulkFunctionForConfirmation] =
    useState('');
  const [bulkActionLoading, setBulkActionLoading] = useState(false);
  const [importLoading, setimportLoading] = useState(false);
  const [pathName, setPathName] = useState(false);

  const [pagination, setPagination] = useState({
    total: 0,
    current_page: 1,
    last_page: 1,
    per_page: 30,
  });
  const [filters, setFilters] = useState({
    processCategories: [],
    deliveryStatuses: [],
    orderStatuses: [],
    paymentStatuses: [],
  });
  const { permissions } = usePermissions();
  const permissionKey = permissionMap[pathName];
  const resetStates = () => {
    setBulkOrderStatusAction('');
    setBulkDeliveryStatusAction('');
    setDeliveryDateFilter([]);
    setSelectedOrders(new Set());
    setSearchQuery('');
    setFilters({
      processCategories: [],
      deliveryStatuses: [],
      orderStatuses: [],
      paymentStatuses: [],
    });
  };
  const fetchData = async (page = 1, ifSearch = 0) => {
    setLoading(true);
    const isCatering =
      location.pathname === '/orders-catering' ||
      location.pathname === '/catering-orders';

    try {
      const per_page = 50;
      const query = {
        page,
        per_page,
        search: searchQuery,
        type: isCatering ? 'CATERING' : 'FBZ',
        processCategories: filters.processCategories,
        deliveryStatuses: filters.deliveryStatuses,
        orderStatuses: filters.orderStatuses,
        paymentStatuses: filters.paymentStatuses,
        deliveryDateFilter,
      };
      // const productsData = await fetchProducts(query);
      if (ifSearch) {
        const ordersResponse = await fetchOrders(query);
        if (ordersResponse.orders) {
          setOrders(ordersResponse.orders);
        }
        if (ordersResponse.pagination) {
          setPagination({
            total: ordersResponse.pagination.total,
            current_page: ordersResponse.pagination.current_page,
            last_page: ordersResponse.pagination.last_page,
            per_page: ordersResponse.pagination.per_page,
          });
        }
      } else {
        const [
          ordersResponse,
          orderStatusesResponse,
          deliveryStatusesResponse,
          processCategoriesResponse,
          paymentStatusesResponse,
        ] = await Promise.all([
          fetchOrders(query),
          fetchOrderStatuses(),
          fetchDeliveryStatuses(),
          fetchProcessCategories(),
          fetchPaymentStatuses(),
        ]);
        if (ordersResponse.orders) {
          setOrders(ordersResponse.orders);
        }
        if (orderStatusesResponse.order_statuses) {
          setOrderStatuses(orderStatusesResponse.order_statuses);
        }
        if (deliveryStatusesResponse.delivery_statuses) {
          setDeliveryStatuses(deliveryStatusesResponse.delivery_statuses);
        }
        if (processCategoriesResponse.process_categories) {
          setProcessCategories(processCategoriesResponse.process_categories);
        }
        if (paymentStatusesResponse.payment_statuses) {
          setPaymentStatuses(paymentStatusesResponse.payment_statuses);
        }

        if (ordersResponse.pagination) {
          setPagination({
            total: ordersResponse.pagination.total,
            current_page: ordersResponse.pagination.current_page,
            last_page: ordersResponse.pagination.last_page,
            per_page: ordersResponse.pagination.per_page,
          });
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (location.pathname !== pathName) {
      resetStates();
      setPathName(location.pathname);
    }

    const isCatering =
      location.pathname === '/orders-catering' ||
      location.pathname === '/catering-orders';

    if (isOrdersCatering !== isCatering) {
      setIsOrdersCatering(isCatering);
      fetchData();
    } else {
      fetchData(pagination.current_page);
    }
  }, [pagination.current_page, location.pathname]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchData(1, 1);
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [searchQuery, filters, deliveryDateFilter]);

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= pagination.last_page) {
      setPagination((prev) => ({
        ...prev,
        current_page: pageNumber,
      }));
    }
  };

  const handleStatusChange = async (orderId, newStatus, field) => {
    const dataToSend = { orderId, field };
    if (field === 'status') {
      dataToSend.status_id = newStatus;
    } else if (field === 'delivery_status') {
      dataToSend.delivery_status_id = newStatus;
    } else if (field === 'payment_status') {
      dataToSend.payment_status_id = newStatus;
    }
    const response = await updateStatus(dataToSend, orderId);
    if (response.success) {
      setOrders((prevOrders) =>
        prevOrders.map((order) =>
          order.id === orderId ? response.order : order
        )
      );
    }
  };
  const handleReadStatusChange = async (orderId) => {
    const response = await toggleReadStatus(orderId);
    if (response.success) {
      setOrders((prevOrders) =>
        prevOrders.map((order) =>
          order.id === orderId ? response.order : order
        )
      );
    }
  };
  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      const allItemsId = orders.map((order) => order.id);
      setSelectedOrders(new Set(allItemsId));
    } else {
      setSelectedOrders(new Set());
    }
  };
  const handleFilterChange = (filterType, value) => {
    setFilters((prev) => {
      const newFilterState = { ...prev };
      if (value === 'ALL') {
        // Toggle all items for the current filter type (categories, origins, or process locations)
        newFilterState[filterType] =
          newFilterState[filterType].length ===
          filterTypeData[filterType].length
            ? [] // Deselect all
            : filterTypeData[filterType].map((item) => item.id); // Select all
      } else {
        newFilterState[filterType] = newFilterState[filterType].includes(value)
          ? newFilterState[filterType].filter((item) => item !== value) // Deselect the item
          : [...newFilterState[filterType], value]; // Select the item
      }

      return newFilterState;
    });
  };
  const handleDateFilterChange = (date, dateString) => {
    console.log('date:', data, 'date string', dateString);
    setDeliveryDateFilterCommonState(date);
    setDeliveryDateFilter(dateString);
  };

  const filterTypeData = {
    processCategories: processCategories,
    deliveryStatuses: deliveryStatuses,
    orderStatuses: orderStatuses,
    paymentStatuses: paymentStatuses,
  };
  const handleRowSelect = (e, id) => {
    const isChecked = e.target.checked;
    setSelectedOrders((prevSelected) => {
      const updatedSelection = new Set(prevSelected);
      if (isChecked) {
        updatedSelection.add(id);
      } else {
        updatedSelection.delete(id);
      }
      return updatedSelection;
    });
  };
  const openBulkUpdateConfirmationModal = (type) => {
    if (selectedOrders.size === 0) {
      showWarningToast(t('NOORDERSELECTED'));
      return;
    }
    if (type === 'orderStatus') {
      if (!bulkOrderStatusAction) {
        showWarningToast(t('PLEASESELECTANOPTIONTOPERFORM'));
        return;
      }
    } else if (type === 'readStatus') {
      if (!bulkReadStatus) {
        showWarningToast(t('PLEASESELECTANOPTIONTOPERFORM'));
        return;
      }
    } else {
      if (!bulkDeliveryStatusAction) {
        showWarningToast(t('PLEASESELECTANOPTIONTOPERFORM'));
        return;
      }
    }
    setBulkFunctionForConfirmation(type);
    setBulkUpdateConfirmationModal(true);
  };

  const onSuccessBulkUpdateConfirmation = async () => {
    await handleBulkActions(bulkFunctionForConfirmation);
    setBulkUpdateConfirmationModal(false);
  };
  const handleBulkActions = async (type) => {
    setBulkActionLoading(true);

    const selectedOrdersIds = Array.from(selectedOrders);
    let response;
    if (type === 'readStatus') {
      response = await toggleReadStatusBulk({
        ids: selectedOrdersIds,
        action: bulkReadStatus,
      });
    } else {
      response = await updateBulkOrders({
        type,
        orders: selectedOrdersIds,
        // isPrint: true,
        action:
          type === 'orderStatus'
            ? bulkOrderStatusAction
            : bulkDeliveryStatusAction,
      });
    }
    if (response.success) {
      showSuccessToast(response?.message || 'Success');
      fetchData(pagination.current_page, 1);
      setSelectedOrders(new Set());
      if (type === 'orderStatus') {
        setBulkOrderStatusAction(null);
      } else if (type === 'readStatus') {
        setBulkReadStatus(null);
      } else {
        setBulkDeliveryStatusAction(null);
      }
    }
    setBulkActionLoading(false);
  };
  const isAllSelected =
    orders.length > 0 && orders.every((order) => selectedOrders.has(order.id));
  const handleModalSuccess = () => {
    setAddModal(false); // Close the modal
    setAddCateringModal(false);
    setEditModal(false);
    setEditCateringModal(false);
    fetchData(1, 1); // Fetch updated data
  };

  const openAddModal = (type, order = {}, isClone = false) => {
    if (type === 'Add-Order') {
      setModalActionType('Add');
      setAddModal(true);
      // Only set selectedOrdersEdit if it's a clone action
      if (isClone) {
        setSelectedOrdersEdit(order);
      } else {
        setSelectedOrdersEdit(''); // Reset for regular add
      }
    } else {
      setModalActionType('Add');
      setAddCateringModal(true);
    }
  };
  const openEditModal = (order) => {
    if (!isOrdersCatering) {
      setModalActionType('Edit');
      setSelectedOrdersEdit(order);
      setEditModal(true);
    } else {
      setModalActionType('Edit');
      setSelectedOrdersEdit(order);
      setEditCateringModal(true);
    }
  };
  const openViewModal = (order) => {
    setSelectedOrdersEdit(order);
    setActionFrom(isOrdersCatering ? 'Catering' : 'Fbz');
    setViewModal(true);
  };
  const openImportModal = (order) => {
    setImportModal(true);
  };
  const handleImportOrders = async (formData) => {
    setimportLoading(true);
    const response = await importOrders(formData);
    setimportLoading(false);
    fetchData(1, 0);
    return response;
    // handleCloseModal("import");
  };
  const handleExportOrders = async () => {
    const data = {
      search: searchQuery,
      processCategories: filters.processCategories,
      deliveryStatuses: filters.deliveryStatuses,
      orderStatuses: filters.orderStatuses,
      deliveryDateFilter,
      type: isOrdersCatering ? 'CATERING' : 'FBZ',
    };

    if (selectedOrders.size !== 0) {
      const selectedOrdersIds = Array.from(selectedOrders);

      data.selectedOrders = selectedOrdersIds;
    }

    const response = await exportOrders(
      data,
      isOrdersCatering
        ? FileNames.CATERING_ORDERS_EXPORT
        : FileNames.FBZ_ORDERS_EXPORT
    );
  };

  const fetchAllOrdersForPrint = async () => {
    setLoading(true);
    const isCatering =
      location.pathname === '/orders-catering' ||
      location.pathname === '/catering-orders';

    try {
      const per_page = 9999999999999;
      const page = 1;
      const query = {
        per_page,
        page,
        search: searchQuery,
        type: isCatering ? 'CATERING' : 'FBZ',
        processCategories: filters.processCategories,
        deliveryStatuses: filters.deliveryStatuses,
        orderStatuses: filters.orderStatuses,
        paymentStatuses: filters.paymentStatuses,
        deliveryDateFilter,
      };

      const ordersResponse = await fetchOrders(query);
      if (ordersResponse.orders) {
        return ordersResponse.orders; // Return all orders for printing
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  const [isPrinting, setIsPrinting] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [downloadInfo, setDownloadInfo] = useState({
    id: null,
    company: '',
    documentType: '',
  });
  const handlePrint = async () => {
    const selectedItems = orders.filter((order) =>
      selectedOrders.has(order.id)
    );

    if (pathName === '/orders-catering' || pathName === '/') {
      const orderIds = Array.from(selectedOrders);

      await handlePrintOrderInfo(selectedItems, isOrdersCatering);

      const matchedStatus = orderStatuses.find((orderStatus) =>
        ['處理中', 'processing'].includes(orderStatus.name.toLowerCase())
      );

      if (matchedStatus) {
        const response = await updateBulkOrders({
          type: 'orderStatus',
          orders: orderIds,
          action: matchedStatus.name,
          isPrint: true,
        });
        if (response.success) {
          showSuccessToast(response?.message || 'Success');
          fetchData(pagination.current_page, 1);
        }
      }
    } else {
      setIsDropdownOpen(!isDropdownOpen);
    }
  };
  const handleDownloadInfoChange = (e) => {
    setDownloadInfo({
      ...downloadInfo,
      company: e.target.value,
    });
  };

  const handleSelectionAndClose = (documentType) => {
    setDownloadInfo({
      ...downloadInfo,
      documentType,
    });
    handleTypeSelection(downloadInfo, documentType);
    setIsDropdownOpen(false); // Close the dropdown after selection
  };
  const handleTypeSelection = (downloadInfo, documentType) => {
    if (!downloadInfo.company) {
      showWarningToast(t('PLEASESELECTCOMPANY'));
      return;
    }

    handleDownload(documentType?.id, documentType);
  };

  const handleDownload = async (orderId, type) => {
    setIsPrinting(true);
    const orderIds = Array.from(selectedOrders);
    const queryData = {
      orderId: orderIds, // Now it's an array, not a Set
      type,
      company: downloadInfo.company,
    };
    try {
      const printResponse = await printView(queryData, type + '.pdf');
      if (printResponse?.success) {
        // update status//

        const matchedStatus = orderStatuses.find((orderStatus) =>
          ['處理中', 'processing'].includes(orderStatus.name.toLowerCase())
        );

        if (matchedStatus) {
          const response = await updateBulkOrders({
            type: 'orderStatus',
            orders: orderIds,
            action: matchedStatus.name,
            isPrint: true,
          });
          if (response.success) {
            showSuccessToast(response?.message || 'Success');
            fetchData(pagination.current_page, 1);
          }
        }
      }
    } catch (error) {
      showErrorToast(error?.message);
    }
    setIsPrinting(false);
  };
  const dropdownRef = useRef([]);

  // Handle clicks outside the dropdown
  useEffect(() => {
    // const handleClickOutside = (event) => {
    //   if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
    //     setIsDropdownOpen(false);
    //   }
    // };
    const handleClickOutside = (event) => {
      const isClickInsideAnyDropdown = dropdownRef.current.some(
        (ref) => ref && ref.contains(event.target)
      );

      if (!isClickInsideAnyDropdown) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return (
    <main className="homepage">
      <section className="main-section fbz-order frbz-cateering">
        {/* <section className="data auto-main-block">
          <div className="row">
            <div className="col-sm-12 col-xl-5 col-md-12">
              <div className="left">
                <h1>
                  {isOrdersCatering ? t('CATERINGORDERS') : t('FBZORDERS')}{' '}
                </h1>
                <div className="input-div">
                  <div className="read-more-search">
                    <div className="input-card">
                      <img src="images/search-icon.svg" alt="" />
                      <input
                        type="text"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        placeholder={t('SEARCH')}
                      />
                    </div>
                    {(pathName === '/' || pathName === '/orders-catering') && (
                      <div className="status">
                        {permissions?.[permissionKey]?.edit_permission ===
                          1 && (
                          <div className="read-status">
                            <h3>{t('READ')}</h3>
                            <div className="order-card">
                              {[
                                { name: t('READ'), value: 'read' },
                                { name: t('UNREAD'), value: 'unread' },
                              ].map((status, i) => (
                                <label key={i} className="container">
                                  {status.name}

                                  <input
                                    type="checkbox"
                                    checked={bulkReadStatus === status.value}
                                    onChange={() =>
                                      setBulkReadStatus(
                                        bulkReadStatus === status.value
                                          ? null
                                          : status.value
                                      )
                                    }
                                  />
                                  <span className="checkmark"></span>
                                </label>
                              ))}
                              <button
                                className="update"
                                onClick={() =>
                                  openBulkUpdateConfirmationModal('readStatus')
                                }
                              >
                                {t('UPDATE')}
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  {(pathName === '/' || pathName === '/orders-catering') && (
                    <div className="status">
                      {permissions?.[permissionKey]?.edit_permission === 1 && (
                        <div className="order-status">
                          <h3>{t('ORDERSTATUS')}</h3>
                          <div className="order-card">
                            {orderStatuses.map((orderStatus, i) => (
                              <label key={i} className="container">
                                {orderStatus.name}

                                <input
                                  type="checkbox"
                                  checked={
                                    bulkOrderStatusAction === orderStatus.name
                                  }
                                  onChange={() =>
                                    setBulkOrderStatusAction(
                                      bulkOrderStatusAction === orderStatus.name
                                        ? null
                                        : orderStatus.name
                                    )
                                  }
                                />
                                <span className="checkmark"></span>
                              </label>
                            ))}
                            <button
                              className="update"
                              onClick={() =>
                                openBulkUpdateConfirmationModal('orderStatus')
                              }
                            >
                              {t('UPDATE')}
                            </button>
                          </div>
                        </div>
                      )}
                      {permissions?.[permissionKey]?.edit_permission === 1 && (
                        <div className="order-status">
                          <h3>{t('DELIVERYSTATUS')}</h3>
                          <div className="order-card">
                            {deliveryStatuses.map((deliveryStatus, i) => (
                              <label key={i} className="container">
                                {deliveryStatus.name}

                                <input
                                  type="checkbox"
                                  checked={
                                    bulkDeliveryStatusAction ===
                                    deliveryStatus.name
                                  }
                                  onChange={() =>
                                    setBulkDeliveryStatusAction(
                                      bulkDeliveryStatusAction ===
                                        deliveryStatus.name
                                        ? null
                                        : deliveryStatus.name
                                    )
                                  }
                                />
                                <span className="checkmark"></span>
                              </label>
                            ))}
                            <button
                              className="update"
                              onClick={() =>
                                openBulkUpdateConfirmationModal(
                                  'deliveryStatus'
                                )
                              }
                            >
                              {t('UPDATE')}
                            </button>
                          </div>
                        </div>
                      )}
                      {/* {permissions?.[permissionKey]?.edit_permission === 1 && (
                        <div className="read-status">
                          <h3>{t('READ')}</h3>
                          <div className="order-card">
                            {[
                              { name: t('READ'), value: 'read' },
                              { name: t('UNREAD'), value: 'unread' },
                            ].map((status, i) => (
                              <label key={i} className="container">
                                {status.name}

                                <input
                                  type="checkbox"
                                  checked={bulkReadStatus === status.value}
                                  onChange={() =>
                                    setBulkReadStatus(
                                      bulkReadStatus === status.value
                                        ? null
                                        : status.value
                                    )
                                  }
                                />
                                <span className="checkmark"></span>
                              </label>
                            ))}
                            <button
                              className="update"
                              onClick={() =>
                                openBulkUpdateConfirmationModal('readStatus')
                              }
                            >
                              {t('UPDATE')}
                            </button>
                          </div>
                        </div>
                      )} */}
        {/* </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-xl-7 col-sm-12">
              <div className="right">
                <div className="filter-container">
                  <div className="filter-section date">
                    <label>{t('DELIVERYDATE')}</label>
                    <div className="date-picker range-picker">
                      <RangePicker
                        key={pathName}
                        onChange={handleDateFilterChange}
                        value={deliveryDateFilterCommonState}
                        separator={'-'}
                        placeholder={[t('FROM'), t('TO')]}
                      />
                    </div>
                  </div>

                  <div className="filter-section">
                    <label>{t('ORDERSTATUS')}</label>
                    <div className="pro-filter checkbox-group">
                      <label className="custom-checkbox">
                        {t('ALL')}
                        <input
                          type="checkbox"
                          checked={
                            filters.orderStatuses.length ===
                            orderStatuses.length
                          }
                          onChange={() =>
                            handleFilterChange('orderStatuses', 'ALL')
                          }
                        />
                        <span className="checkmark"></span>
                      </label>
                      {orderStatuses.map((orderStatus) => (
                        <label key={orderStatus.id} className="custom-checkbox">
                          {orderStatus.name}
                          <input
                            type="checkbox"
                            checked={filters.orderStatuses.includes(
                              orderStatus.id
                            )}
                            onChange={() =>
                              handleFilterChange(
                                'orderStatuses',
                                orderStatus.id
                              )
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                      ))}
                    </div>
                  </div>

                  <div className="filter-section">
                    <label>{t('DELIVERYSTATUS')}</label>
                    <div className="pro-filter checkbox-group">
                      <label className="custom-checkbox">
                        {t('ALL')}
                        <input
                          type="checkbox"
                          checked={
                            filters.deliveryStatuses.length ===
                            deliveryStatuses.length
                          }
                          onChange={() =>
                            handleFilterChange('deliveryStatuses', 'ALL')
                          }
                        />
                        <span className="checkmark"></span>
                      </label>
                      {deliveryStatuses.map((deliveryStatus) => (
                        <label
                          key={deliveryStatus.id}
                          className="custom-checkbox"
                        >
                          {deliveryStatus.name}
                          <input
                            type="checkbox"
                            checked={filters.deliveryStatuses.includes(
                              deliveryStatus.id
                            )}
                            onChange={() =>
                              handleFilterChange(
                                'deliveryStatuses',
                                deliveryStatus.id
                              )
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                      ))}
                    </div>
                  </div>
                  {(pathName === '/' ||
                    pathName === '/orders-catering' ||
                    pathName === '/catering-orders') && (
                    <div className="pro-filter filter-section">
                      <label>{t('PROCESSCATEGORY')}</label>
                      <div className="checkbox-group pro-filter">
                        <label className="custom-checkbox">
                          {t('ALL')}
                          <input
                            type="checkbox"
                            checked={
                              filters.processCategories.length ===
                              processCategories.length
                            }
                            onChange={() =>
                              handleFilterChange('processCategories', 'ALL')
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                        {processCategories.map((processCategory) => (
                          <label
                            key={processCategory.id}
                            className="custom-checkbox"
                          >
                            {processCategory.name}
                            <input
                              type="checkbox"
                              checked={filters.processCategories.includes(
                                processCategory.id
                              )}
                              onChange={() =>
                                handleFilterChange(
                                  'processCategories',
                                  processCategory.id
                                )
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        ))}
                      </div>
                    </div>
                  )}

                  {pathName === '/fbz-orders' && (
                    <div className="filter-section">
                      <label>{t('PAYMENTSTATUS')}</label>
                      <div className="pro-filter checkbox-group">
                        <label className="custom-checkbox">
                          {t('ALL')}
                          <input
                            type="checkbox"
                            checked={
                              filters.paymentStatuses.length ===
                              paymentStatuses.length
                            }
                            onChange={() =>
                              handleFilterChange('paymentStatuses', 'ALL')
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                        {paymentStatuses.map((paymentStatus) => (
                          <label
                            key={paymentStatus.id}
                            className="custom-checkbox"
                          >
                            {paymentStatus.name}
                            <input
                              type="checkbox"
                              checked={filters.paymentStatuses.includes(
                                paymentStatus.id
                              )}
                              onChange={() =>
                                handleFilterChange(
                                  'paymentStatuses',
                                  paymentStatus.id
                                )
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        ))}
                      </div>
                    </div>
                  )}

                  <div
                    className={`button-group prints-show-dp ${pathName == '/catering-orders' ? 'hide-printbtn' : ''}`}
                  >
                    {permissions?.[permissionKey]?.edit_permission === 1 && (
                      <button
                        onClick={() => {
                          openImportModal();
                        }}
                      >
                        {' '}
                        <img src="images/import.svg" alt="" />
                        {t('IMPORT')}
                      </button>
                    )}
                    <button onClick={handleExportOrders}>
                      <img src="images/export.svg" alt="" />
                      {t('EXPORT')}
                    </button>
                    {pathName !== '/catering-orders' && (
                      <div
                        className="position-relative"
                        ref={(el) => (dropdownRef.current[0] = el)}
                      >
                        <button
                          onClick={handlePrint}
                          disabled={selectedOrders.size === 0 || isPrinting}
                          className="print position-relative"
                          // ref={dropdownRef}
                        >
                          <img src="images/print.svg" alt="" />
                          {isPrinting ? t('LOADING') : t('PRINT')}
                        </button>

                        {isDropdownOpen && (
                          <div className="dropdown-menu show print-drop-down">
                            <div className="dropdown-menu-list ">
                              <label className="d-block w-100 px-2 pt-2">
                                {t('SELECTCOMPANY')}
                              </label>
                              <div className="radio">
                                <p className="mb-0">
                                  <input
                                    type="radio"
                                    id="test3"
                                    name="radio-group2"
                                    value="Fruttiboz"
                                    checked={
                                      downloadInfo.company === 'Fruttiboz'
                                    }
                                    onChange={(e) =>
                                      handleDownloadInfoChange(e)
                                    }
                                  />
                                  <label htmlFor="test1">
                                    {t('FRUTTIBOZ')}
                                  </label>
                                </p>
                                <p className="mb-0">
                                  <input
                                    type="radio"
                                    id="test4"
                                    name="radio-group2"
                                    value="Freco"
                                    checked={downloadInfo.company === 'Freco'}
                                    onChange={(e) =>
                                      handleDownloadInfoChange(e)
                                    }
                                  />
                                  <label htmlFor="test2">{t('FRECO')}</label>
                                </p>
                              </div>
                            </div>
                            <ul>
                              <li>
                                <a
                                  className={`dropdown-item ${!downloadInfo.company ? 'disabled' : ''}`}
                                  onClick={() => {
                                    if (downloadInfo.company)
                                      handleSelectionAndClose('INVOICE');
                                  }}
                                  style={{
                                    cursor: !downloadInfo.company
                                      ? 'not-allowed'
                                      : 'pointer',
                                  }}
                                >
                                  {t('INVOICE')}
                                </a>
                              </li>
                              <li>
                                <a
                                  className={`dropdown-item ${!downloadInfo.company ? 'disabled' : ''}`}
                                  onClick={() => {
                                    if (downloadInfo.company)
                                      handleSelectionAndClose('DN');
                                  }}
                                  style={{
                                    cursor: !downloadInfo.company
                                      ? 'not-allowed'
                                      : 'pointer',
                                  }}
                                >
                                  {t('DELIVERYNOTE')}
                                </a>
                              </li>
                              <li>
                                <a
                                  className={`dropdown-item ${!downloadInfo.company ? 'disabled' : ''}`}
                                  onClick={() => {
                                    if (downloadInfo.company)
                                      handleSelectionAndClose('RECEIPT');
                                  }}
                                  style={{
                                    cursor: !downloadInfo.company
                                      ? 'not-allowed'
                                      : 'pointer',
                                  }}
                                >
                                  {t('RECEIPT')}
                                </a>
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    )}

                    {permissions?.[permissionKey]?.edit_permission === 1 && (
                      <button
                        className="add-btn"
                        onClick={() => {
                          openAddModal(
                            isOrdersCatering ? 'Add-Catering' : 'Add-Order'
                          );
                        }}
                      >
                        + {t('ADD')}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>  */}

        {/* --------------------------------------on 1512px screen change data */}
        <section className="data on-responsive-block">
          <div className="row">
            <div className="col-sm-12 col-xl-3 col-md-12">
              <div className="left">
                <h1>{isOrdersCatering ? 'Catering Orders' : 'FBZ Orders'} </h1>
                <div className="input-div">
                  <div className="input-card">
                    <img src="images/search-icon.svg" alt="" />
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder={t('SEARCH')}
                    />
                  </div>
                  <div className="filter-section date">
                    <label>{t('DELIVERYDATE')}</label>
                    <div className="date-picker range-picker">
                      <RangePicker
                        key={pathName}
                        onChange={handleDateFilterChange}
                        value={deliveryDateFilterCommonState}
                        separator={'-'}
                        placeholder={[t('FROM'), t('TO')]}
                      />
                    </div>
                  </div>
                  {/* {(pathName === '/' || pathName === '/orders-catering') && (
                    <div className="status">
                      {permissions?.[permissionKey]?.edit_permission === 1 && (
                        <div className="order-status">
                          <h3>{t('ORDERSTATUS')}</h3>
                          <div className="order-card">
                            {orderStatuses.map((orderStatus, i) => (
                              <label key={i} className="container">
                                {orderStatus.name}

                                <input
                                  type="checkbox"
                                  checked={
                                    bulkOrderStatusAction === orderStatus.name
                                  }
                                  onChange={() =>
                                    setBulkOrderStatusAction(
                                      bulkOrderStatusAction === orderStatus.name
                                        ? null
                                        : orderStatus.name
                                    )
                                  }
                                />
                                <span className="checkmark"></span>
                              </label>
                            ))}
                            <button
                              className="update"
                              onClick={() => openBulkUpdateConfirmationModal('orderStatus')}
                            >
                              {t('UPDATE')}
                            </button>
                          </div>
                        </div>
                      )}
                      {permissions?.[permissionKey]?.edit_permission === 1 && (
                        <div className="order-status">
                          <h3>{t('DELIVERYSTATUS')}</h3>
                          <div className="order-card">
                            {deliveryStatuses.map((deliveryStatus, i) => (
                              <label key={i} className="container">
                                {deliveryStatus.name}

                                <input
                                  type="checkbox"
                                  checked={
                                    bulkDeliveryStatusAction ===
                                    deliveryStatus.name
                                  }
                                  onChange={() =>
                                    setBulkDeliveryStatusAction(
                                      bulkDeliveryStatusAction ===
                                        deliveryStatus.name
                                        ? null
                                        : deliveryStatus.name
                                    )
                                  }
                                />
                                <span className="checkmark"></span>
                              </label>
                            ))}
                            <button
                              className="update"
                              onClick={() => openBulkUpdateConfirmationModal('deliveryStatus')}
                            >
                              {t('UPDATE')}
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  )} */}
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-xl-4 col-sm-12">
              <div className="right">
                <div className="filter-container">
                  <div className="filter-section">
                    <label>{t('ORDERSTATUS')}</label>
                    <div className="pro-filter checkbox-group">
                      <label className="custom-checkbox">
                        {t('ALL')}
                        <input
                          type="checkbox"
                          checked={
                            filters.orderStatuses.length ===
                            orderStatuses.length
                          }
                          onChange={() =>
                            handleFilterChange('orderStatuses', 'ALL')
                          }
                        />
                        <span className="checkmark"></span>
                      </label>
                      {orderStatuses.map((orderStatus) => (
                        <label key={orderStatus.id} className="custom-checkbox">
                          {orderStatus.name}
                          <input
                            type="checkbox"
                            checked={filters.orderStatuses.includes(
                              orderStatus.id
                            )}
                            onChange={() =>
                              handleFilterChange(
                                'orderStatuses',
                                orderStatus.id
                              )
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                      ))}
                    </div>
                  </div>

                  <div className="filter-section">
                    <label>{t('DELIVERYSTATUS')}</label>
                    <div className="pro-filter checkbox-group">
                      <label className="custom-checkbox">
                        {t('ALL')}
                        <input
                          type="checkbox"
                          checked={
                            filters.deliveryStatuses.length ===
                            deliveryStatuses.length
                          }
                          onChange={() =>
                            handleFilterChange('deliveryStatuses', 'ALL')
                          }
                        />
                        <span className="checkmark"></span>
                      </label>
                      {deliveryStatuses.map((deliveryStatus) => (
                        <label
                          key={deliveryStatus.id}
                          className="custom-checkbox"
                        >
                          {deliveryStatus.name}
                          <input
                            type="checkbox"
                            checked={filters.deliveryStatuses.includes(
                              deliveryStatus.id
                            )}
                            onChange={() =>
                              handleFilterChange(
                                'deliveryStatuses',
                                deliveryStatus.id
                              )
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                      ))}
                    </div>
                  </div>
                  {(pathName === '/' ||
                    pathName === '/orders-catering' ||
                    pathName === '/catering-orders') && (
                    <div className="pro-filter filter-section">
                      <label>{t('PROCESSCATEGORY')}</label>
                      <div className="checkbox-group pro-filter">
                        <label className="custom-checkbox">
                          {t('ALL')}
                          <input
                            type="checkbox"
                            checked={
                              filters.processCategories.length ===
                              processCategories.length
                            }
                            onChange={() =>
                              handleFilterChange('processCategories', 'ALL')
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                        {processCategories.map((processCategory) => (
                          <label
                            key={processCategory.id}
                            className="custom-checkbox"
                          >
                            {processCategory.name}
                            <input
                              type="checkbox"
                              checked={filters.processCategories.includes(
                                processCategory.id
                              )}
                              onChange={() =>
                                handleFilterChange(
                                  'processCategories',
                                  processCategory.id
                                )
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        ))}
                      </div>
                    </div>
                  )}
                  {pathName === '/fbz-orders' && (
                    <div className="filter-section">
                      <label>{t('PAYMENTSTATUS')}</label>
                      <div className="pro-filter checkbox-group">
                        <label className="custom-checkbox">
                          {t('ALL')}
                          <input
                            type="checkbox"
                            checked={
                              filters.paymentStatuses.length ===
                              paymentStatuses.length
                            }
                            onChange={() =>
                              handleFilterChange('paymentStatuses', 'ALL')
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                        {paymentStatuses.map((paymentStatus) => (
                          <label
                            key={paymentStatus.id}
                            className="custom-checkbox"
                          >
                            {paymentStatus.name}
                            <input
                              type="checkbox"
                              checked={filters.paymentStatuses.includes(
                                paymentStatus.id
                              )}
                              onChange={() =>
                                handleFilterChange(
                                  'paymentStatuses',
                                  paymentStatus.id
                                )
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-xl-5 col-sm-12">
              <div className="right right-change-cs">
                <div className="filter-container">
                  {/* <div className="filter-section date">
                    <label>{t('DELIVERYDATE')}</label>
                    <div className="date-picker range-picker">
                      <RangePicker
                        key={pathName}
                        onChange={handleDateFilterChange}
                        separator={'-'}
                        placeholder={[t('FROM'), t('TO')]}
                      />
                    </div>
                  </div> */}

                  {/* {pathName === '/fbz-orders' && (
                    <div className="filter-section">
                      <label>{t('PAYMENTSTATUS')}</label>
                      <div className="pro-filter checkbox-group">
                        <label className="custom-checkbox">
                          {t('ALL')}
                          <input
                            type="checkbox"
                            checked={
                              filters.paymentStatuses.length ===
                              paymentStatuses.length
                            }
                            onChange={() =>
                              handleFilterChange('paymentStatuses', 'ALL')
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                        {paymentStatuses.map((paymentStatus) => (
                          <label
                            key={paymentStatus.id}
                            className="custom-checkbox"
                          >
                            {paymentStatus.name}
                            <input
                              type="checkbox"
                              checked={filters.paymentStatuses.includes(
                                paymentStatus.id
                              )}
                              onChange={() =>
                                handleFilterChange(
                                  'paymentStatuses',
                                  paymentStatus.id
                                )
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        ))}
                      </div>
                    </div>
                  )} */}

                  <div
                    className={`button-group prints-show-dp ${pathName == '/catering-orders' ? 'hide-printbtn' : ''}`}
                  >
                    {permissions?.[permissionKey]?.edit_permission === 1 && (
                      <button
                        className="add-btn"
                        onClick={() => {
                          openAddModal(
                            isOrdersCatering ? 'Add-Catering' : 'Add-Order'
                          );
                        }}
                      >
                        + {t('ADD')}
                      </button>
                    )}
                    {permissions?.[permissionKey]?.edit_permission === 1 && (
                      <button
                        onClick={() => {
                          openImportModal();
                        }}
                      >
                        {' '}
                        <img src="images/import.svg" alt="" />
                        {t('IMPORT')}
                      </button>
                    )}
                    <button onClick={handleExportOrders}>
                      <img src="images/export.svg" alt="" />
                      {t('EXPORT')}
                    </button>
                    {pathName !== '/catering-orders' && (
                      <div
                        className="position-relative"
                        ref={(el) => (dropdownRef.current[1] = el)}
                      >
                        <button
                          onClick={handlePrint}
                          disabled={selectedOrders.size === 0 || isPrinting}
                          className="print position-relative"
                          // ref={dropdownRef}
                        >
                          <img src="images/print.svg" alt="" />
                          {isPrinting ? t('LOADING') : t('PRINT')}
                        </button>

                        {isDropdownOpen && (
                          <div className="dropdown-menu show print-drop-down">
                            <div className="dropdown-menu-list ">
                              <label className="d-block w-100 px-2 pt-2">
                                {t('SELECTCOMPANY')}
                              </label>
                              <div className="radio">
                                <p className="mb-0">
                                  <input
                                    type="radio"
                                    id="test1"
                                    name="radio-group"
                                    value="Fruttiboz"
                                    checked={
                                      downloadInfo.company === 'Fruttiboz'
                                    }
                                    onChange={(e) =>
                                      handleDownloadInfoChange(e)
                                    }
                                  />
                                  <label htmlFor="test1">
                                    {t('FRUTTIBOZ')}
                                  </label>
                                </p>
                                <p className="mb-0">
                                  <input
                                    type="radio"
                                    id="test2"
                                    name="radio-group"
                                    value="Freco"
                                    checked={downloadInfo.company === 'Freco'}
                                    onChange={(e) =>
                                      handleDownloadInfoChange(e)
                                    }
                                  />
                                  <label htmlFor="test2">{t('FRECO')}</label>
                                </p>
                              </div>
                            </div>
                            <ul>
                              <li>
                                <a
                                  className={`dropdown-item ${!downloadInfo.company ? 'disabled' : ''}`}
                                  onClick={() => {
                                    if (downloadInfo.company)
                                      handleSelectionAndClose('INVOICE');
                                  }}
                                  style={{
                                    cursor: !downloadInfo.company
                                      ? 'not-allowed'
                                      : 'pointer',
                                  }}
                                >
                                  {t('INVOICE')}
                                </a>
                              </li>
                              <li>
                                <a
                                  className={`dropdown-item ${!downloadInfo.company ? 'disabled' : ''}`}
                                  onClick={() => {
                                    if (downloadInfo.company)
                                      handleSelectionAndClose('DN');
                                  }}
                                  style={{
                                    cursor: !downloadInfo.company
                                      ? 'not-allowed'
                                      : 'pointer',
                                  }}
                                >
                                  {t('DELIVERYNOTE')}
                                </a>
                              </li>
                              <li>
                                <a
                                  className={`dropdown-item ${!downloadInfo.company ? 'disabled' : ''}`}
                                  onClick={() => {
                                    if (downloadInfo.company)
                                      handleSelectionAndClose('RECEIPT');
                                  }}
                                  style={{
                                    cursor: !downloadInfo.company
                                      ? 'not-allowed'
                                      : 'pointer',
                                  }}
                                >
                                  {t('RECEIPT')}
                                </a>
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    )}

                    {/* {permissions?.[permissionKey]?.edit_permission === 1 && (
                      <button
                        className="add-btn"
                        onClick={() => {
                          openAddModal(
                            isOrdersCatering ? 'Add-Catering' : 'Add-Order'
                          );
                        }}
                      >
                        + {t('ADD')}
                      </button>
                    )} */}
                  </div>
                </div>
                {(pathName === '/' || pathName === '/orders-catering') && (
                  <div className="status">
                    {permissions?.[permissionKey]?.edit_permission === 1 && (
                      <div className="order-status">
                        <h3>{t('ORDERSTATUS')}</h3>
                        <div className="order-card">
                          {orderStatuses.map((orderStatus, i) => (
                            <label key={i} className="container">
                              {orderStatus.name}

                              <input
                                type="checkbox"
                                checked={
                                  bulkOrderStatusAction === orderStatus.name
                                }
                                onChange={() =>
                                  setBulkOrderStatusAction(
                                    bulkOrderStatusAction === orderStatus.name
                                      ? null
                                      : orderStatus.name
                                  )
                                }
                              />
                              <span className="checkmark"></span>
                            </label>
                          ))}
                          <button
                            className="update"
                            onClick={() =>
                              openBulkUpdateConfirmationModal('orderStatus')
                            }
                          >
                            {t('UPDATE')}
                          </button>
                        </div>
                      </div>
                    )}
                    {permissions?.[permissionKey]?.edit_permission === 1 && (
                      <div className="order-status">
                        <h3>{t('DELIVERYSTATUS')}</h3>
                        <div className="order-card">
                          {deliveryStatuses.map((deliveryStatus, i) => (
                            <label key={i} className="container">
                              {deliveryStatus.name}

                              <input
                                type="checkbox"
                                checked={
                                  bulkDeliveryStatusAction ===
                                  deliveryStatus.name
                                }
                                onChange={() =>
                                  setBulkDeliveryStatusAction(
                                    bulkDeliveryStatusAction ===
                                      deliveryStatus.name
                                      ? null
                                      : deliveryStatus.name
                                  )
                                }
                              />
                              <span className="checkmark"></span>
                            </label>
                          ))}
                          <button
                            className="update"
                            onClick={() =>
                              openBulkUpdateConfirmationModal('deliveryStatus')
                            }
                          >
                            {t('UPDATE')}
                          </button>
                        </div>
                      </div>
                    )}
                    {permissions?.[permissionKey]?.edit_permission === 1 && (
                      <div className="order-status read-status justify-content-end">
                        <h3>{t('READ')}</h3>
                        <div className="order-card">
                          {[
                            { name: t('READ'), value: 'read' },
                            { name: t('UNREAD'), value: 'unread' },
                          ].map((status, i) => (
                            <label key={i} className="container">
                              {status.name}

                              <input
                                type="checkbox"
                                checked={bulkReadStatus === status.value}
                                onChange={() =>
                                  setBulkReadStatus(
                                    bulkReadStatus === status.value
                                      ? null
                                      : status.value
                                  )
                                }
                              />
                              <span className="checkmark"></span>
                            </label>
                          ))}
                          <button
                            className="update"
                            onClick={() =>
                              openBulkUpdateConfirmationModal('readStatus')
                            }
                          >
                            {t('UPDATE')}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
        {/* <!-- /main data --> */}
        {/* <!-- table --> */}
        {/* <div
          className={`table-outer ${orders.length >= 1 && orders.length <= 3 ? 'scroll' : ''}`}
        > */}
        {pathName === '/' ||
        pathName === '/orders-catering' ||
        pathName === '/catering-orders' ? (
          <OrdersTable
            permissionKey={permissionKey}
            orders={orders}
            loading={loading}
            isAllSelected={isAllSelected}
            handleSelectAllChange={handleSelectAllChange}
            selectedOrders={selectedOrders}
            handleRowSelect={handleRowSelect}
            permissions={permissions}
            isOrdersCatering={isOrdersCatering}
            orderStatuses={orderStatuses}
            handleStatusChange={handleStatusChange}
            deliveryStatuses={deliveryStatuses}
            openEditModal={openEditModal}
            openViewModal={openViewModal}
            handleReadStatusChange={handleReadStatusChange}
            pathName={pathName}
            colorMappings={colorMappings}
            fetchData={fetchData}
            pagination={pagination}
          />
        ) : (
          <FBZOrdersTable
            permissionKey={permissionKey}
            orders={orders}
            loading={loading}
            isAllSelected={isAllSelected}
            handleSelectAllChange={handleSelectAllChange}
            selectedOrders={selectedOrders}
            handleRowSelect={handleRowSelect}
            permissions={permissions}
            isOrdersCatering={isOrdersCatering}
            orderStatuses={orderStatuses}
            handleStatusChange={handleStatusChange}
            deliveryStatuses={deliveryStatuses}
            paymentStatuses={paymentStatuses}
            openEditModal={openEditModal}
            openViewModal={openViewModal}
            openAddModal={openAddModal}
            colorMappings={colorMappings}
          />
        )}
        {/* </div> */}
        <Pagination
          currentPage={pagination.current_page}
          totalPages={pagination.last_page}
          paginate={paginate}
          loading={loading}
        />

        {/* -----------Update modal new------------------- */}
        <Modal
          isOpen={addModal}
          onRequestClose={() => setAddModal(false)}
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          overlayClassName={`modal-overlay add `}
          portalClassName="add"
        >
          <AddOrderModalUpdate
            setAddModal={setAddModal}
            actionType={modalActionType}
            selectedOrdersEdit={selectedOrdersEdit}
            onSuccess={handleModalSuccess}
          />
        </Modal>

        <Modal
          isOpen={addCateringModal}
          onRequestClose={() => setAddCateringModal(false)}
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          overlayClassName={`modal-overlay add `}
          portalClassName="add"
        >
          <AddCateringModal
            actionType={modalActionType}
            setAddCateringModal={setAddCateringModal}
            onSuccess={handleModalSuccess}
          />
        </Modal>
        {/* -----------Update modal new------------------- */}

        {/* Edit Fbz Modal */}
        <Modal
          isOpen={editModal}
          onRequestClose={() => setEditModal(false)}
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          overlayClassName={`modal-overlay add `}
          portalClassName="add"
        >
          <EditOrderModal
            setEditModal={setEditModal}
            actionType={modalActionType}
            selectedOrdersEdit={selectedOrdersEdit}
            onSuccess={handleModalSuccess}
          />
        </Modal>
        {/* Edit Fbz Modal */}

        {/* Edit Catering Modal */}
        <Modal
          isOpen={editCateringModal}
          onRequestClose={() => setEditCateringModal(false)}
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          overlayClassName={`modal-overlay add `}
          portalClassName="add"
        >
          <EditCateringModal
            setEditCateringModal={setEditCateringModal}
            actionType={modalActionType}
            selectedOrdersEdit={selectedOrdersEdit}
            onSuccess={handleModalSuccess}
          />
        </Modal>
        {/* Edit Catering Modal */}

        <Modal
          isOpen={viewModal}
          onRequestClose={() => setViewModal(false)}
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          overlayClassName={`modal-overlay add `}
          portalClassName="add view-modal"
        >
          <ViewOrderModal
            setViewModal={setViewModal}
            selectedOrdersEdit={selectedOrdersEdit}
            setAddModal={isOrdersCatering ? setEditCateringModal : setEditModal}
            // setAddModal={setAddModal}
            actionFrom={actionFrom}
            isOrdersCatering={isOrdersCatering}
          />
        </Modal>
        <Modal
          isOpen={importModal}
          onRequestClose={() => setImportModal(false)}
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          overlayClassName={`modal-overlay add `}
          portalClassName="add"
        >
          <ImportOrdersModal
            setImportModal={setImportModal}
            handleImportOrders={handleImportOrders}
            importLoading={importLoading}
            type={isOrdersCatering ? 'CATERING' : 'FBZ'}
          />
        </Modal>
        <Modal
          isOpen={bulkUpdateConfirmationModal}
          onRequestClose={() => setBulkUpdateConfirmationModal(false)}
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          overlayClassName={`modal-overlay add confirmation-update`}
          portalClassName="add"
        >
          <BulkUpdateConfirmationModal
            setConfirmationModal={setBulkUpdateConfirmationModal}
            onSuccess={onSuccessBulkUpdateConfirmation}
            loading={bulkActionLoading}
          />
        </Modal>
      </section>
    </main>
  );
}
